<template>
  <div v-if="core" ref="container" class="plv-ia-app plv-ia-qn-new">
    <!-- 问卷列表-->
    <QuestionnaireList
      v-if="currentStep === STEP.QUESTIONNAIRE_LIST"
      ref="questionnaireList"
      :lang="lang"
      :core="core"
      @create-questionnaire="showCreateQuestionnaire"
      @edit-questionnaire="showEditQuestionnaire"
      @start-questionnaire="startQuestionnaire"
      @show-statistics="showStatistics"
      @download-statistics="downloadStatistics"
      @change-current-step="changeCurrentStep"
      @stop-questionnaire="stopQuestionnaire"
      @send-result="sendResult"
    />
    <!-- 创建问卷和编辑问卷 -->
    <QuestionnaireEdit
      v-if="currentStep === STEP.QUESTIONNAIRE_EDIT"
      :lang="lang"
      :questionnaire-id="questionnaireId"
      :privacy="privacy"
      :isFullPreview.sync="isFullPreview"
      :core="core"
      @start-questionnaire="startQuestionnaire"
      @save-questionnaire="saveQuestionnaire"
      @change-current-step="changeCurrentStep"/>
    <QuestionnaireStatistics
      v-if="currentStep === STEP.QUESTIONNAIRE_STATISTICS"
      :questionnaire-id="questionnaireId"
      :core="core"
      :lang="lang"
      @download-statistics="downloadStatistics"
      @change-current-step="changeCurrentStep"
      @send-result="sendResult"
    />

  </div>
</template>

<script type="text/babel">
import Vue from 'vue';
import Locale from '@/mixins/locale';

import commonMixin from '../app-mixin';

import { STEP, STATUS, parseSaveQuestionnaire } from '@/assets/app/questionnaire/helper';
import QuestionnaireEdit from './components/QuestionnaireEdit';
import QuestionnaireList from './components/QuestionnaireList';
import QuestionnaireStatistics from './components/QuestionnaireStatistics';
import sendRoomMixin from '../../mixins/vclass/send-room';
import { installIcon } from '@polyv/icons-vue';
import * as IconMap from './icon-components/map.ts';
installIcon(Vue, {
  customIcons: IconMap,
});

export default {
  name: 'QuestionnaireNew',

  mixins: [Locale, commonMixin, sendRoomMixin],
  components: {
    QuestionnaireList,
    QuestionnaireEdit,
    QuestionnaireStatistics,
  },
  props: {
    /** 问卷 SDK 实例 */
    core: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      STEP,
      currentStep: STEP.QUESTIONNAIRE_LIST,
      questionnaireId: null,
      privacy: null,
      isFullPreview: false,
    };
  },

  computed: {},
  mounted() {
    window.a = this;
  },

  methods: {
    changeCurrentStep(step) {
      if (step === STEP.QUESTIONNAIRE_LIST) {
        this.isFullPreview = false;
      }
      this.currentStep = step;
    },
    // 创建问卷
    showCreateQuestionnaire() {
      this.questionnaireId = null;
      this.privacy = null;
      this.changeCurrentStep(STEP.QUESTIONNAIRE_EDIT);
    },
    // 打开问卷创建/编辑页
    showEditQuestionnaire(item, isFullPreview) {
      this.questionnaireId = item.questionnaireId;
      this.privacy = item.privacy;
      this.isFullPreview = isFullPreview;
      this.changeCurrentStep(STEP.QUESTIONNAIRE_EDIT);
    },
    // 打开问卷统计页
    showStatistics(item) {
      this.questionnaireId = item.questionnaireId;
      this.changeCurrentStep(STEP.QUESTIONNAIRE_STATISTICS);
    },
    async startQuestionnaire(questionnaire, step = STEP.QUESTIONNAIRE_LIST, pushNewQuestionnaire = true) {
      // 重新发布
      let questionnaireDetail;
      let saveQuestionnaireData;
      try {
        questionnaireDetail = await this.core.getQuestionnaireDetail(questionnaire.questionnaireId);
        questionnaireDetail.privacy = {
          content: questionnaireDetail.privacyContent,
          required: questionnaireDetail.privacyEnabled,
        };
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
      // 重发：重新创建一份相同问卷发布
      if (questionnaire.status === STATUS.FINISHED) {
        const saveData = parseSaveQuestionnaire(questionnaireDetail);
        saveData.questionnaireId = '';
        saveQuestionnaireData = await this.saveQuestionnaire(saveData, true);
        questionnaireDetail = await this.core.getQuestionnaireDetail(saveQuestionnaireData.questionnaireId);
      }
      try {
        await this.core.start(questionnaireDetail);
        // 重发后，问卷列表插入最新一条问卷数据
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
      try {
        if (questionnaire.status === STATUS.FINISHED) {
          // 从其他页跳转列表页，不需要插入新的问卷数据
          if (!pushNewQuestionnaire) return;
          this.$nextTick(async () => {
            if (this.$refs.questionnaireList) {
              const saveQuestionnaireDetail = await this.core.getQuestionnaireDetail(saveQuestionnaireData.questionnaireId);
              const item = {
                createdTime: saveQuestionnaireDetail.createdTime,
                questionnaireId: saveQuestionnaireDetail.questionnaireId,
                name: saveQuestionnaireDetail.name,
                status: saveQuestionnaireDetail.status,
                total: 0,
                privacy: {
                  content: saveQuestionnaireDetail.privacyContent,
                  required: saveQuestionnaireDetail.privacyEnabled,
                }
              };
              this.$refs.questionnaireList.pushNewQuestionnaire(item);
            }
          });
        }
        this.changeCurrentStep(step);
      } catch (error) {
        this.$iaMessage.default(error.message);
      }

    },
    downloadStatistics(questionnaireId) {
      this.core.downloadStatistics(questionnaireId);
    },
    async saveQuestionnaire(data, isRepublish = false) {
      let result;
      try {
        result = await this.core.save(data);
        if (!isRepublish) {
          this.$iaMessage.default('保存成功');
          this.changeCurrentStep(STEP.QUESTIONNAIRE_LIST);
        }
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
      return result;
    },
    stopQuestionnaire(questionnaire) {
      try {
        this.core.stop(questionnaire.questionnaireId);
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
    },

    async sendResult(questionnaire) {
      // if (questionnaire.questions && questionnaire.questions.filter(item => item.isScorable).length <= 0) {
      //   this.$iaMessage.default(this.t('plvIA.questionnaire.noAnswer'));
      //   return;
      // }
      try {
        await this.core.sendResult(questionnaire.questionnaireId);
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
    },
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/main.scss';
@import '../../assets/styles/button-new.scss';
//$imgPrefix: './images/';
.plv-ia-qn-new {
  height: 100%;
  overflow: hidden;

  input[type=number]:focus {
    border-color: var(--interactBlue);
  }

  input[type=checkbox] {
    cursor: pointer;
    position: relative;
    width: 13px;
    height: 13px;
    font-size: 12px;
  }

  input[type=checkbox]::after {
    position: absolute;
    top: 0;
    width: 13px;
    height: 13px;
    text-align: center;
    content: ' ';
    border-radius: 3px;
  }

  input[type=checkbox]:checked::after {
    content: ' ';
    background-image: url('../../assets/svg/questuonnaire/icon-checkbox.svg');
    background-size: 100% 100%;
  }
}
.plv-ia-qn-new-question-color--blue {
  color: var(--interactBlue);
}
.plv-ia-qn-new-question-color--red {
  color: #FC1212;
}
.plv-ia-qn-new-icon {
  box-sizing: border-box;
  height: 24px;
  width: 24px;
}
</style>
